import React from 'react';
import {useDeviceSize, DeviceSize} from '../../../shared/theme/helpers';
import {useStyles} from '../../../shared/hooks/styles';
import {Text} from '../../../shared/components/text';
import {StyleProp, TextStyle} from 'react-native';

export const Title: React.FC<{title: string; showHelpText?: boolean; titleStyle?: StyleProp<TextStyle>}> = ({
  title,
  showHelpText,
  titleStyle,
}) => {
  const deviceSize = useDeviceSize();
  const styles = useStyles(({theme, mediaOnly}) => {
    return {
      helpText: {
        textAlign: 'center',
        alignItems: 'center',
        marginTop: 4,
        ...mediaOnly(DeviceSize.desktop, {width: 311, marginHorizontal: 'auto'}, {width: 290, marginHorizontal: 30}),
        ...mediaOnly(
          DeviceSize.desktop,
          {
            ...theme.fonts.bodySmallLight,
            color: theme.color.gray500,
          },
          {
            ...theme.fonts.caption,
            color: theme.color.gray500,
            fontSize: 12 * theme.fontSizeZoom,
          },
        ),
      },
      title: {
        ...theme.fonts.h3,
        textAlign: 'center',
        color: theme.color.textColor,
      },
      titleMobile: {
        ...theme.fonts.h6,
        textAlign: 'center',
        color: theme.color.textColor,
      },
    };
  });

  return (
    <>
      <Text
        testID='login-title-id'
        style={[deviceSize === DeviceSize.desktop ? styles.title : styles.titleMobile, titleStyle]}>
        {title}
      </Text>
      {showHelpText ? (
        <Text testID='login-hepl-text-id' style={styles.helpText}>
          Получение доступа к сервисам портала{'\n'}“Единая карта жителя Мурманской области”
        </Text>
      ) : null}
    </>
  );
};
